import { render } from "./TextReveal.vue?vue&type=template&id=1d0da53e"
import script from "./TextReveal.vue?vue&type=script&lang=js"
export * from "./TextReveal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__